import React from 'react';
import { useEffect } from 'react';
import { Outlet, useLocation, matchPath } from 'react-router-dom';
import withFirebase from '../../Firebase/withFirebase';
import {
  callNativeAppRouteChanged,
  callNativeMobileApp,
  useTranslator,
} from '@front-activerse/common-components';
import { Route } from '../types';

/* eslint-disable-next-line */
export interface RegularRouteProps {
  title?: string;
  mobileAppTabIdentifier?: string;
  updateScene: (
    sceneId: number,
    lastPlaybackPosition: number,
    isPlaybackCompleted: boolean,
    __typename: string
  ) => any;
  trackFirebaseEvent: any;
  descendantRoutes: Route[];
  routePath: string;
}

export function RegularRoute(props: RegularRouteProps) {
  const location = useLocation();
  const { t } = useTranslator();

  const matchedRoute = props.descendantRoutes?.find((descendantRoute) =>
    matchPath(props.routePath.slice(0, -2) + descendantRoute.path, location.pathname)
  );

  useEffect(() => {
    // old webview navigation - remove after mobile navigation are updated
    callNativeAppRouteChanged(
      window.location.pathname,
      props.mobileAppTabIdentifier,
      t(`${matchedRoute ? matchedRoute.title : props.title}`)
    );

    // new webview navigation
    // disable title change if disableTitleChangePostMsg (set in descendant routes) is true
    if (!matchedRoute?.disableTitleChangePostMsg) {
      callNativeMobileApp({
        action: 'title_changed',
        payload: {
          title: t(`${matchedRoute ? matchedRoute.title : props.title}`),
        },
      });
    }

    const lastPlayedSceneString = sessionStorage.getItem('lastPlayedAudioToUpdate');

    if (lastPlayedSceneString && !location.pathname.includes('motivation')) {
      const lastPlayedScene = JSON.parse(lastPlayedSceneString);
      const update = async () => {
        const res = await props.updateScene(
          lastPlayedScene.sceneId,
          lastPlayedScene.lastPlaybackPosition,
          lastPlayedScene.isCompleted,
          lastPlayedScene.__typename
        );

        if (res.scene.updateScenePlaybackMetadata.code === 200) {
          sessionStorage.removeItem('lastPlayedAudioToUpdate');
        }
      };

      if (lastPlayedScene) {
        update();
      }
    }
  }, [location, props]);
  return <Outlet context={{ brand: 'shestong', trackFirebaseEvent: props.trackFirebaseEvent }} />;
}

export default withFirebase(RegularRoute);
